import { Routes, RouterModule } from '@angular/router'
import { IndexComponent } from '@client/Components/Index/Index.Component'
import { PageNotFoundComponent } from '@client/Components/PageNotFound'
import { ContactComponent } from '@client/Components/Contact/Contact.Component'
import { AccommodationComponent } from '@client/Components/Accommodation/Accommodation.Component'
import { LoginComponent } from '@client/Components/Auth/Login/Login.Component'
import { LoggedOutGuard } from '@client/Services/Guards/LoggedOutGuard'
import { ResetPasswordComponent } from '@client/Components/Auth/ResetPassword/ResetPassword.Component'
import { SecurityComponent } from '@client/Components/Security/Security.Component'
import { ForgottenPasswordComponent } from '@client/Components/Auth/ForgottenPassword/ForgottenPassword.Component'
import { LoggedInGuard } from '@client/Services/Guards/LoggedInGuard'
import { AccountComponent } from '@client/Components/Account/Account.Component'
import { GuestComponent } from '@client/Components/Guests/Guest/Guest.Component'
import { OrdersComponent } from '@client/Components/Orders/Orders.Component'
import { OrderComponent } from '@client/Components/Orders/Order/Order.Component'
import { SetupOrderPaymentPlanComponent } from '@client/Components/Orders/Order/PaymentPlans/SetupOrderPaymentPlan.Component'
import { PaymentPlanComponent } from '@client/Components/Orders/Order/PaymentPlans/PaymentPlan.Component'

const appRoutes: Routes = [
	{
		path: '',
		component: IndexComponent,
	},
	{
		path: 'contact',
		component: ContactComponent,
	},
	{
		path: 'accommodation',
		component: AccommodationComponent,
	},
	{
		path: 'forgotten-password',
		component: ForgottenPasswordComponent,
		canActivate: [LoggedOutGuard],
	},
	{
		path: 'login',
		component: LoginComponent,
		canActivate: [LoggedOutGuard],
	},
	{
		path: 'reset-password/:token',
		component: ResetPasswordComponent,
		canActivate: [LoggedOutGuard],
	},
	{
		path: 'my-account',
		canActivate: [LoggedInGuard],
		children: [
			{
				path: '',
				component: AccountComponent,
			},
			{
				path: 'guests',
				canActivate: [LoggedInGuard],
				children: [
					{
						path: '',
						component: PageNotFoundComponent,
					},
					{
						path: ':id',
						component: GuestComponent,
					},
				],
			},
			{
				path: 'orders',
				canActivate: [LoggedInGuard],
				children: [
					{
						path: '',
						component: OrdersComponent,
					},
					{
						path: ':id',
						component: OrderComponent,
					},
					{
						path: ':id/payment-plans/setup',
						component: SetupOrderPaymentPlanComponent,
					},
					{
						path: ':id/payment-plans/setup/:step',
						component: SetupOrderPaymentPlanComponent,
					},
					{
						path: ':id/payment-plans/:planId',
						component: PaymentPlanComponent,
					},
				],
			},
			{
				path: 'security',
				component: SecurityComponent,
			},
		],
	},
	{
		path: '**',
		component: PageNotFoundComponent,
	},
]

export const appRoutingProviders: any[] = []

export const routing = RouterModule.forRoot(appRoutes)
